import axios from 'axios';
import get from 'lodash/get';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import qs from 'query-string';
import qsFilters from 'qs';

import { thunkHandler, thunkErrorHanlder, parseUrl, Consequence } from '../../libs/utils';

import {
  INVOICE_BASE,
  INVOICE_SINGLE,
  INVOICE_SINGLE_COLLECTION,
  INVOICE_COLLECTION,
  INVOICE_FILES,
  INVOICE_NOTE,
  INVOICE_EXPORT,
  INVOICE_SINGLE_COLLECTION_SMS,
  CREDIT_NOTE_BASE,
  CREDIT_NOTE_SINGLE,
  CLIENT_INVOICES,
} from '../../constants/endpoints';

import reminderExample from '../resources/reminder_example.json';

export const SEND_COLLECTION_NOTICE = 'SEND_COLLECTION_NOTICE';
export const NEW_SINGLE_INVOICE = 'NEW_SINGLE_INVOICE';
export const NEW_INVOICE_COLLECTION = 'NEW_INVOICE_COLLECTION';
export const NEW_INVOICE_ITEMS = 'NEW_INVOICE_ITEMS';
export const NEW_INVOICES = 'NEW_INVOICES';
export const INVOICES_TO_PAY = 'INVOICES_TO_PAY';
export const NEW_INVOICE_NOTE = 'NEW_INVOICE_NOTE';
export const NEW_EXPORT_INVOICES = 'NEW_EXPORT_INVOICES';
export const NEW_IMPORT_INVOICES = 'NEW_IMPORT_INVOICES';
export const NEW_IMPORT_NOTES = 'NEW_IMPORT_NOTES';
export const NEW_SINGLE_CREDIT_NOTE = 'NEW_SINGLE_CREDIT_NOTE';
export const NEW_FILTERS = 'NEW_FILTERS';
export const NEW_LOADING_TABLE = 'NEW_LOADING_TABLE';
export const NEW_SEARCHING = 'NEW_SEARCHING';
export const RELOAD_INVOIDE_TABLE = 'RELOAD_INVOIDE_TABLE';

export function sendCollectionNotice(uuid, body) {
  return axios.post(parseUrl(INVOICE_COLLECTION, { uuid }), body);
}

export function sendCollectionNoticeSms(uuid, body) {
  return axios.post(parseUrl(INVOICE_SINGLE_COLLECTION_SMS, { uuid }), body);
}

export function createNewInvoiceNote(body) {
  return dispatch => axios.post(INVOICE_NOTE, body)
    .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_SINGLE_INVOICE, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

export function getInvoices(params, source) {
  if (typeof params !== 'object' && !Array.isArray(params)) params = {};
  const qsObj = {};
  const { activeTab, page, code, customer, startDate, endDate, cancelToken } = params;

  if (activeTab && source) qsObj.filter = filterCatalog(activeTab);
  if (activeTab && activeTab === '6') qsObj.filter = filterCatalog(activeTab);
  if (activeTab && !source && activeTab !== '6') qsObj.type = newfilterCatalog(activeTab);
  if (page) qsObj.page = page;
  if (code) qsObj.code = code;
  if (customer) qsObj.customer = customer;
  if (startDate) {
    qsObj.start = startDate;
    qsObj.end = endDate || moment().format('YYYY-MM-DD');
  }
  if (typeof params.dueDate === 'number') qsObj.due = params.dueDate;

  if (activeTab && activeTab === '7') {
    return dispatch => axios.get(`${CREDIT_NOTE_BASE}?${qs.stringify(qsObj)}`, cancelToken ? { cancelToken: cancelToken.token } : {})
      .then(res => thunkHandler(dispatch, get(res, 'data.data.data', []), NEW_INVOICES, 'ERROR', res))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
  }

  return dispatch => axios.get(`${INVOICE_BASE}?${qs.stringify(qsObj)}`, cancelToken ? { cancelToken: cancelToken.token } : {})
    .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_INVOICES, 'ERROR', res))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

export function getReminders(params, productTour = 'inactive', options = {}) {
  if (typeof params !== 'object' && !Array.isArray(params)) params = {};
  const qsObj = {};
  const { activeTab, page, code, customer, startDate, endDate, cancelToken } = params;

  if (activeTab) qsObj.filter = filterCatalog(activeTab);
  if (page) qsObj.page = page;
  if (code) qsObj.code = code;
  if (customer) qsObj.customer = customer;
  if (startDate) {
    qsObj.start = startDate;
    qsObj.end = endDate || moment().format('YYYY-MM-DD');
  }
  if (typeof params.dueDate === 'number') qsObj.due = params.dueDate;

  return dispatch => axios.get(`${INVOICE_BASE}?${qs.stringify(qsObj)}`, cancelToken ? { cancelToken: cancelToken.token } : {})
    .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_INVOICES, 'ERROR', res))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

function filterCatalog(n) {
  switch (parseInt(n)) {
    case 1: return;
    case 2: return 'paid';
    case 3: return 'late_payment';
    case 4: return 'current';
    case 6: return 'cancel';
    default: return 'uncollectable';
  }
}

function newfilterCatalog(n) {
  switch (parseInt(n)) {
    case 1: return;
    case 2: return 'cfdi';
    case 3: return 'invoice';
    case 4: return 'recurrent';
    case 6: return 'cancel';
  }
  return null;
}

export function exportInvoices(params = {}, source) {
  if (typeof params !== 'object') params = {};
  const qsObj = {};
  const { activeTab, page, code, customer, startDate, endDate } = params;

  if (activeTab && source) qsObj.filter = filterCatalog(activeTab);
  if (activeTab && !source && activeTab !== '6') qsObj.type = newfilterCatalog(activeTab);
  if (activeTab && activeTab === '6') qsObj.filter = filterCatalog(activeTab);
  if (page) qsObj.page = page;
  if (code) qsObj.code = code;
  if (customer) qsObj.customer = customer;
  if (startDate) {
    qsObj.start = startDate;
    qsObj.end = endDate || moment().format('YYYY-MM-DD');
  }
  if (typeof params.dueDate === 'number') qsObj.due = params.dueDate;

  return dispatch => axios.get(`${INVOICE_EXPORT}?${qs.stringify(qsObj)}`, { responseType: 'arraybuffer' })
    .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_EXPORT_INVOICES, 'ERROR', res))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

export function getSingleInvoice(uuid) {
  return dispatch => axios.get(parseUrl(INVOICE_SINGLE, { uuid }))
    .then(res => thunkHandler(dispatch, get(res, 'data.data', {}), NEW_SINGLE_INVOICE, 'ERROR'));
}

export function updateSingleInvoice(uuid, body) {
  return dispatch => axios.patch(parseUrl(INVOICE_SINGLE, { uuid }), body)
    .then(() => {
      return setTimeout(() => {
        axios.get(parseUrl(INVOICE_SINGLE, { uuid }))
          .then(res => thunkHandler(dispatch, get(res, 'data.data', {}), NEW_SINGLE_INVOICE, 'ERROR'))
          .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
      }, 2500);
    });
}

export function updateInvoiceNotesLocal(uuid, body) {
  return dispatch => axios.patch(parseUrl(INVOICE_SINGLE, { uuid }), body)
    .then(() => axios.get(parseUrl(INVOICE_SINGLE, { uuid })))
    .then(res => {
      const payloadNotes = get(body, 'notes');
      const invoice = get(res, 'data.data', {});
      const invoiceNotes = get(invoice, 'notes');

      if (payloadNotes !== invoiceNotes) invoice.notes = payloadNotes;

      return thunkHandler(dispatch, invoice, NEW_SINGLE_INVOICE, 'ERROR');
    });
}

export function updateInvoiceCollectionLocal(uuid, body) {
  return dispatch => axios.patch(parseUrl(INVOICE_SINGLE, { uuid }), body)
    .then(() => axios.get(parseUrl(INVOICE_SINGLE, { uuid })))
    .then(res => {
      const collectiblePayload = get(body, 'collectible');
      const invoice = get(res, 'data.data', {});
      const collectibleInvoice = get(invoice, 'collectible');

      if (collectiblePayload !== collectibleInvoice) invoice.collectible = collectiblePayload;

      return thunkHandler(dispatch, invoice, NEW_SINGLE_INVOICE, 'ERROR');
    });
}

export function addFilesToInvoice(uuid, body) {
  const options = { headers: { 'content-type': 'multipart/form-data' } };
  return dispatch => axios.post(parseUrl(INVOICE_FILES, { uuid }), body, options)
    .then(() => axios.get(parseUrl(INVOICE_SINGLE, { uuid })))
    .then(res => new Consequence({
      dispatch,
      payload: { data: get(res, 'data.data', {}) },
      eventTypes: { success: NEW_SINGLE_INVOICE, error: 'ERROR' }
    }));
}

export function getSingleInvoiceCollection(uuid, axiosConfiguration = {}, productTour = 'inactive') {
  const productTourReminder = reminderExample[0];

  function parseDemoReminder(reminder) {
    reminder.date = moment().unix();
    return reminder;
  }

  if (productTour === 's2') {
    const objectResponse = { data: { data: [parseDemoReminder(productTourReminder)] } };
    return dispatch => Promise.resolve(objectResponse)
      .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_INVOICE_COLLECTION, 'ERROR'))
      .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
  }

  return dispatch => axios.get(parseUrl(INVOICE_SINGLE_COLLECTION, { uuid }), axiosConfiguration)
    .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_INVOICE_COLLECTION, 'ERROR'))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

export function getClientUnpaidInvoices(uuid) {
  return dispatch => axios.get(`${parseUrl(CLIENT_INVOICES, { uuid })}?filter=to_pay`)
    .then(res => new Consequence({
      dispatch,
      payload: { data: get(res, 'data.data', {}) },
      eventTypes: { success: NEW_INVOICES, error: 'ERROR' }
    }));
}

export function cancelInvoice(uuid, cfdi_seal_version, motive_id, uuid_replacement) {
  const data = { motive_id, cfdi_seal_version };
  if (uuid_replacement) data.uuid_replacement = uuid_replacement;

  return dispatch => axios.delete(parseUrl(`${INVOICE_SINGLE}/cancel`, { uuid }), { data })
    .then(() => axios.get(parseUrl(INVOICE_SINGLE, { uuid })))
    .then(res => new Consequence({
      dispatch,
      payload: { data: get(res, 'data.data', {}) },
      eventTypes: { success: NEW_SINGLE_INVOICE, error: 'ERROR' }
    }));
}

export function getInvoiceCreditNotes(uuid) {
  return dispatch => axios.get(`${CREDIT_NOTE_BASE}/by-contract/${uuid}`)
    .then(res => thunkHandler(dispatch, get(res, 'data.data', {}), NEW_SINGLE_CREDIT_NOTE, 'ERROR'));
}

export function getVisibilityFilters(filters, updateTable = true, searching = true) {
  return dispatch => Promise.resolve(dispatch({
    type: NEW_FILTERS,
    payload: { filters, updateTable, searching }
  }));
}

export function updateLoadingTable(loadingTable) {
  return dispatch => Promise.resolve(dispatch({
    type: NEW_LOADING_TABLE,
    payload: loadingTable
  }));
}

export function getInvoicesV2(allFilters, cancelToken) {
  if (typeof allFilters !== 'object' && !Array.isArray(allFilters)) allFilters = {};
  const { personalized = {}, filters = {} } = allFilters;
  const emptyAllFilters = isEmpty(allFilters);
  const emptyPersonalized = isEmpty(personalized);
  const emptyFilters = isEmpty(filters);
  const qsPersonalizedConfig = { encode: false };
  let url = `${INVOICE_BASE}`;

  const normalizeInvoiceStatus = (statusValue) => {
    if (typeof statusValue !== 'string') return statusValue;
    const aliasToId = {
      late_payment: '2',
      current: '3',
      paid: '5',
      cancel: '6'
    };
    return statusValue
      .split(',')
      .map((s) => s.trim().toLowerCase())
      .filter(Boolean)
      .map((s) => (Object.prototype.hasOwnProperty.call(aliasToId, s) ? aliasToId[s] : s))
      .join(',');
  };

  if (Object.prototype.hasOwnProperty.call(personalized, 'status')) {
    personalized.status = normalizeInvoiceStatus(personalized.status);
  }
  if (Object.prototype.hasOwnProperty.call(filters, 'status')) {
    filters.status = normalizeInvoiceStatus(filters.status);
  }

  if (has(personalized, 'credit_note')) {
    url = `${CREDIT_NOTE_BASE}`;
    delete personalized.credit_note;
  }

  if (!emptyAllFilters) {
    if (!emptyPersonalized) url = url.concat(`?${qsFilters.stringify(personalized, qsPersonalizedConfig)}`);
    if (!emptyFilters) {
      let strFilters = String(qsFilters.stringify(filters)).replace(/&/gi, '%26').split('-').join('');
      url = url.concat(`${emptyPersonalized ? '?filters=' : '&filters='}${strFilters}`);
    }
  }

  return dispatch => axios.get(url, cancelToken ? { cancelToken: cancelToken.token } : {})
    .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_INVOICES, 'ERROR', res))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

export function exportInvoicesV2(allFilters) {
  if (typeof allFilters !== 'object' && !Array.isArray(allFilters)) allFilters = {};
  const { personalized = {}, filters = {} } = allFilters;
  const emptyAllFilters = isEmpty(allFilters);
  const emptyPersonalized = isEmpty(personalized);
  const emptyFilters = isEmpty(filters);
  const qsPersonalizedConfig = { encode: false };
  let url = `${INVOICE_EXPORT}`;

  const normalizeInvoiceStatus = (statusValue) => {
    if (typeof statusValue !== 'string') return statusValue;
    const aliasToId = {
      late_payment: '2',
      current: '3',
      paid: '5',
      cancel: '6'
    };
    return statusValue
      .split(',')
      .map((s) => s.trim().toLowerCase())
      .filter(Boolean)
      .map((s) => (Object.prototype.hasOwnProperty.call(aliasToId, s) ? aliasToId[s] : s))
      .join(',');
  };

  if (Object.prototype.hasOwnProperty.call(personalized, 'status')) {
    personalized.status = normalizeInvoiceStatus(personalized.status);
  }
  if (Object.prototype.hasOwnProperty.call(filters, 'status')) {
    filters.status = normalizeInvoiceStatus(filters.status);
  }

  if (has(personalized, 'credit_note')) {
    url = `${CREDIT_NOTE_BASE}`;
    delete personalized.credit_note;
  }

  if (!emptyAllFilters) {
    if (!emptyPersonalized) url = url.concat(`?${qsFilters.stringify(personalized, qsPersonalizedConfig)}`);
    if (!emptyFilters) {
      let strFilters = String(qsFilters.stringify(filters)).replace(/&/gi, '%26');
      url = url.concat(`${emptyPersonalized ? '?filters=' : '&filters='}${strFilters}`);
    }
  }

  return dispatch => axios.get(url, { responseType: 'arraybuffer' })
    .then(res => thunkHandler(dispatch, get(res, 'data.data', []), NEW_EXPORT_INVOICES, 'ERROR', res))
    .catch(error => thunkErrorHanlder(error, dispatch, 'ERROR'));
}

export function resetSearching() {
  return dispatch => Promise.resolve(dispatch({
    type: NEW_SEARCHING,
    payload: false
  }));
}

export const setReloadInvoiceTable = (isReload = false) => {
  return dispatch =>
    Promise.resolve(
      dispatch({ type: RELOAD_INVOIDE_TABLE, payload: isReload })
    );
};



// WEBPACK FOOTER //
// ./src/redux/actions/invoiceActions.js